import React from 'react'
import './index.scss'

export default function Icon(props: any) {

    const {
        style = {},
        icon = '',
        onClick = function () { }
    } = props

    return (
        <i className={`iconfont ${props.className || ''}`} style={{ padding: '0 .106667rem', ...style }} onClick={onClick} dangerouslySetInnerHTML={{ __html: icon }}></i>
    )

}